module.exports = __webpack_public_path__ + "static/media/CS181.ad291cfb.PNG";